var _rect, _path, _path2, _path3, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckoutLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 96,
    height: 96,
    rx: 48,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.4954 25.8936V34.148H59.4C64.1773 34.148 66.6932 37.1444 66.6932 41.3282C66.6932 45.5119 64.1773 48.6215 59.4 48.6215H50.8063L49.0254 56.4801H59.4282C69.7745 56.4801 76.248 50.996 76.248 41.2716C76.2197 31.5473 68.8134 25.8936 58.4954 25.8936Z",
    fill: "#3A66FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3682 39.5478L37.8877 39.5196H36.8983C36.2764 32.9047 32.6863 32.8199 32.4884 32.8199C32.4601 32.8199 29.6332 32.5655 24.2905 37.569L23.4707 38.3323L23.8947 37.3146C28.7569 25.781 38.5661 25.668 38.6509 25.668H46.9053C47.2446 25.668 47.5555 25.9224 47.6121 26.2333C47.7534 26.8552 48.1209 27.562 49.2799 27.5902C50.4106 27.5902 50.8064 26.8835 50.9195 26.2899C51.0043 25.9224 51.3152 25.668 51.6827 25.668H55.075C55.8382 25.668 57.2516 26.1203 57.2516 27.8164V32.622C57.2516 33.3287 56.9972 33.8093 56.6863 34.1203C56.2057 34.6008 55.5273 34.7704 55.1032 34.7422H51.8523C51.4 34.7422 51.0326 34.4312 50.9195 34.0072C50.7781 33.4701 50.3541 32.8199 49.2799 32.8199C49.2799 32.8199 48.1774 32.7068 47.0467 33.6114C45.7746 34.6574 44.9831 36.5514 44.7287 39.2651V39.2934C44.7287 39.2934 44.7287 39.2934 44.7287 39.3217L44.7004 39.5196H38.4813L38.3682 39.5478Z",
    fill: "#3A66FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8125 39.4912H44.6429V73.8375C44.6429 74.1202 44.4167 74.3181 44.1623 74.3181H37.2931C37.0104 74.3181 36.8125 74.0919 36.8125 73.8375V39.4912Z",
    fill: "#3A66FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 96,
    height: 96,
    rx: 48,
    stroke: "#EBECEF",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckoutLogo);
export default __webpack_public_path__ + "static/media/checkout_logo.1885d0bba6e1c1d452bb1525ed579dc3.svg";
export { ForwardRef as ReactComponent };